import { ISavedSearchesState } from '../../types/savedSearches';

const defaultState: ISavedSearchesState = {
  count: 0,
};

export function savedSearchesReducer(state: ISavedSearchesState = defaultState): ISavedSearchesState {
  return state;
}
